import React, { useState } from 'react'
import './SchemePlayground.css';
import store from '../../../../stateManagement/store';
import { Row, SchemePlaygroundType } from '../../types';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef, GridColumnHeaderParams, GridRenderCellParams } from '@mui/x-data-grid';
import { Button, Tooltip } from '@mui/material';
import RenderSvg from '../../../../components/renderSvg/RenderSvg';
import { ConfirmationPopUp } from '../../../../components/popup/confirmationPopUp';
import { inPlaygroundMode, labelMappings } from '../../utils/utils';
import { postSchemeReduxState, reinitialiseCouponState } from '../../../../stateManagement/actions/manageCouponActions';
import { ChannelkartNetworkPatch } from '../../../../services/networkService';
import { useSelector } from 'react-redux';
import PreviewApp from './PreviewApp';

function SchemePlayground() {
  const data: SchemePlaygroundType = useSelector(() => store.getState().schemePlayground)

  async function postClick(schemeId: string) {
    try {
      const res = await ChannelkartNetworkPatch('/v1/schemes/update?status=approved&schemeId=' + schemeId);
      postSchemeReduxState(schemeId)
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  async function editClick(schemeId: string) {
    try {
      data.data[schemeId].data.couponEditType = inPlaygroundMode;
      data.data[schemeId].data.couponId = schemeId;
      reinitialiseCouponState(data.data[schemeId]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const ViewAndEditColumn: React.FC<{ row: Row }> = ({ row }) => {
    const [editOpen, seteditOpen] = useState<boolean>(false);
    let schemeId: string = Object.values(row)[0];
    const handleViewButtonClick = (row: Row) => {
      seteditOpen(true)
    };
    return (
      <div>
        <div
          className="edit-button"
          onClick={() => handleViewButtonClick(row)}>
          <RenderSvg name="Reset-password" />
          {/* <span className="edit-button-text">View/Edit</span> */}
        </div>
        <ConfirmationPopUp
          openConfirmModal={editOpen}
          setOpenConfirmModal={seteditOpen}
          message={labelMappings["EDIT_COUPON"]}
          successMethod={() => { editClick(schemeId) }}
          rejectMethod={() => { seteditOpen(false); }}
        />
      </div>

    );
  };


  const PostColumn: React.FC<{ row: Row }> = ({ row }) => {
    const [postOpen, setPostOpen] = useState<boolean>(false);
    let schemeId: string = Object.values(row)[0];
    const handlePostButtonClick = (row: Row) => {
      setPostOpen(true)
    };
    return (
      <div>
        <Button variant="contained" onClick={() => handlePostButtonClick(row)}>
          Post
        </Button>
        <ConfirmationPopUp
          openConfirmModal={postOpen}
          setOpenConfirmModal={setPostOpen}
          message={labelMappings["POST_COUPON"]}
          successMethod={() => { postClick(schemeId) }}
          rejectMethod={() => { setPostOpen(false); }}
        />
      </div>
    );
  };

  const columns: GridColDef[] = [
    {
      field: 'schemeId',
      headerName: 'Scheme ID',
      flex: 1,
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      headerClassName: 'scheme-playground-col',
      renderHeader: (params: GridColumnHeaderParams) => (
        <Tooltip title="Coupon ID">
          <b>Scheme ID</b>
        </Tooltip>
      ),
    },
    {
      field: 'edit',
      headerName: 'Edit',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      headerClassName: 'scheme-playground-col',
      renderHeader: (params: GridColumnHeaderParams) => (
        <Tooltip title="Coupon ID">
          <b>Edit</b>
        </Tooltip>
      ),
      renderCell: (params: GridRenderCellParams) => <ViewAndEditColumn row={params.row as Row} />,
    },
    {
      field: 'post',
      headerName: 'Post',
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      headerClassName: 'scheme-playground-col',
      renderHeader: (params: GridColumnHeaderParams) => (
        <Tooltip title="Coupon ID">
          <b>Post</b>
        </Tooltip>
      ),
      renderCell: (params: GridRenderCellParams) => <PostColumn row={params.row as Row} />,
    },
  ];


  const schemeIDs = Object.keys(data.data);
  const rows = schemeIDs.map((schemeId, index) => ({
    schemeId,
  }));
  return (
    <>
        <div className="schemePlayground-container">
          <div className="schemePlayground-cache-schemeDisplay">
            <Box sx={{ minHeight:'88vh',width: '100%' }}>
              <DataGrid
                rows={rows}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                getRowId={(row: any) => row.schemeId}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                disableColumnMenu={true}
              />
            </Box>
            {/* <Button className='post-btn' variant="contained" onClick={() => { }}>
              Post All
            </Button> */}
          </div>
          <div className="schemePlayground-app-container">
            <PreviewApp />
          </div>
        </div>

    </>
  )
}

export default SchemePlayground